import { storageFormatters } from "@jana-technology/platform-ui";

import type {
  GetPublishedUnitConfigurationFieldDto,
  GetRiskUnitLookupDto,
} from "contexts/configuration";

const PUBLISHED_RISK_UNIT_CODES = new Set<PublishedRiskUnitCode>([
  "Dollars",
  "RU",
]);
const RISK_UNIT_DISPLAY_CODE = "RiskUnitDisplay";

type PublishedRiskUnitCode = "Dollars" | "RU";

export type RiskUnitFormatter = (value: number) => string;

const isPublishedRiskUnitCode = (
  value: string | undefined,
): value is PublishedRiskUnitCode => {
  return (
    value !== undefined &&
    PUBLISHED_RISK_UNIT_CODES.has(value as PublishedRiskUnitCode)
  );
};

export const getPublishedRiskUnitCode = (
  publishedUnits: Array<GetPublishedUnitConfigurationFieldDto> | undefined,
  riskUnits: Array<GetRiskUnitLookupDto> | undefined,
): PublishedRiskUnitCode => {
  const publishedRiskUnitId = Number(
    publishedUnits?.find((unit) => unit.code === RISK_UNIT_DISPLAY_CODE)?.value,
  );
  const riskUnitName = riskUnits?.find(
    (unit) => unit.unitId === publishedRiskUnitId,
  )?.name;

  return isPublishedRiskUnitCode(riskUnitName) ? riskUnitName : "Dollars";
};

export const formatRiskUnitValue = (
  value: number,
  riskUnitCode: PublishedRiskUnitCode = "Dollars",
): string => {
  const formattedValue = storageFormatters.number(value);

  return riskUnitCode === "RU" ? `${formattedValue} RU` : `$${formattedValue}`;
};
